(function () {
  function initAtlas(root) {
    if (root.dataset.ready || !window.L || !Array.isArray(window.MapCutsAtlasData)) return;
    root.dataset.ready = 'true';

    var data = window.MapCutsAtlasData;
    var search = root.querySelector('[data-atlas-search]');
    var kind = root.querySelector('[data-atlas-kind]');
    var state = root.querySelector('[data-atlas-state]');
    var county = root.querySelector('[data-atlas-county]');
    var reset = root.querySelector('[data-atlas-reset]');
    var requestedPlace = new URLSearchParams(window.location.search).get('place');
    if (requestedPlace) search.value = requestedPlace;
    var results = root.querySelector('[data-atlas-results]');
    var count = root.querySelector('[data-atlas-count]');
    var fresh = root.querySelector('[data-atlas-fresh]');
    var freshGrid = root.querySelector('[data-atlas-fresh-grid]');
    var freshTitle = root.querySelector('[data-atlas-fresh-title]');
    var freshNote = root.querySelector('[data-atlas-fresh-note]');
    var recent = [];
    var found = [];
    var searchTimer;
    var searchRequest;
    var map = L.map(root.querySelector('[data-atlas-map]'), { scrollWheelZoom: false }).setView([39.5, -96], 4);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 17,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
    var markers = L.layerGroup().addTo(map);
    var labels = { lake: 'Lake map', coast: 'Coastal map', city: 'City map', topo: 'Topographic map', golf: 'Golf map' };
    var placesByHandle = new Map(data.map(function (item) { return [item.url.split('/products/')[1], item]; }));

    function matchesGeography(item) {
      return (!state || state.value === 'all' || (item?.states || []).includes(state.value)) &&
        (!county || county.value === 'all' || (item?.counties || []).some(function (area) { return area.id === county.value; }));
    }

    function geographyText(item) {
      var areas = item.counties || [];
      if (county && county.value !== 'all') areas = areas.filter(function (area) { return area.id === county.value; });
      else if (state && state.value !== 'all') areas = areas.filter(function (area) { return area.state === state.value; });
      if (areas.length && areas.length <= 2) return areas.map(function (area) { return area.name + ', ' + area.state; }).join(' / ');
      return (item.states || []).join(' / ');
    }

    function updateCounties() {
      if (!county || !state) return;
      var previous = county.value;
      county.replaceChildren();
      var option = document.createElement('option');
      option.value = 'all';
      option.textContent = state.value === 'all' ? root.dataset.chooseState : root.dataset.allCounties;
      county.append(option);
      county.disabled = state.value === 'all';
      if (county.disabled) return;
      var areas = new Map();
      data.forEach(function (item) {
        (item.counties || []).forEach(function (area) { if (area.state === state.value) areas.set(area.id, area); });
      });
      Array.from(areas.values()).sort(function (a, b) { return a.name.localeCompare(b.name); }).forEach(function (area) {
        var choice = document.createElement('option');
        choice.value = area.id;
        choice.textContent = area.name;
        county.append(choice);
      });
      if (areas.has(previous)) county.value = previous;
    }

    if (state) {
      Array.from(new Set(data.flatMap(function (item) { return item.states || []; }))).sort().forEach(function (name) {
        var option = document.createElement('option');
        option.value = name;
        option.textContent = name;
        state.append(option);
      });
      updateCounties();
    }

    function productKind(product) {
      var type = String(product.type || product.product_type || '').toLowerCase();
      var title = String(product.title || '').toLowerCase();
      if (type.includes('golf') || title.includes('golf course')) return 'golf';
      if (type.includes('topograph') || title.includes('topographic')) return 'topo';
      if (type.includes('city') || title.includes('city map')) return 'city';
      if (type.includes('coast') || /coast|bay|sound|island|beach/.test(title)) return 'coast';
      if (type.includes('lake') || /lake|reservoir|pond|river/.test(title)) return 'lake';
      return '';
    }

    function renderFresh() {
      if (!fresh) return;
      var query = search.value.trim().toLocaleLowerCase();
      var selected = kind.value;
      var list = (query ? found : recent).filter(function (product) {
        var handle = product.handle || String(product.url || '').split('/products/')[1]?.split('?')[0];
        var productType = productKind(product);
        return productType && matchesGeography(placesByHandle.get(handle)) &&
          (selected === 'all' || productType === selected) &&
          (!query || product.title.toLocaleLowerCase().includes(query));
      }).slice(0, 8);
      fresh.hidden = !list.length;
      if (!list.length) return;
      freshTitle.textContent = query ? 'More matching maps' : 'Recently added maps';
      freshNote.textContent = query ? 'Shop current listings that match your search.' : 'New listings appear here automatically. Pins are added after we check each location.';
      freshGrid.replaceChildren();
      list.forEach(function (product) {
        var card = document.createElement('a');
        card.className = 'mc-atlas-fresh-card';
        card.href = product.url;
        if (product.image) {
          var image = document.createElement('img');
          image.src = product.image;
          image.alt = '';
          image.loading = 'lazy';
          card.append(image);
        }
        var title = document.createElement('strong');
        title.textContent = product.title;
        card.append(title);
        freshGrid.append(card);
      });
    }

    function searchProducts() {
      clearTimeout(searchTimer);
      if (searchRequest) searchRequest.abort();
      found = [];
      renderFresh();
      var query = search.value.trim();
      if (query.length < 2) return;
      searchTimer = setTimeout(function () {
        searchRequest = new AbortController();
        var url = (window.Shopify?.routes?.root || '/') + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10';
        fetch(url, { signal: searchRequest.signal }).then(function (response) {
          if (!response.ok) throw new Error('Search unavailable');
          return response.json();
        }).then(function (body) {
          if (search.value.trim() !== query) return;
          found = body.resources?.results?.products || [];
          renderFresh();
        }).catch(function (error) { if (error.name !== 'AbortError') console.warn('Atlas search unavailable', error); });
      }, 250);
    }

    if (fresh) {
      var feedUrl = (window.Shopify?.routes?.root || '/') + 'collections/all?view=atlas-feed&sort_by=created-descending';
      fetch(feedUrl).then(function (response) {
        if (!response.ok) throw new Error('Recent maps unavailable');
        return response.json();
      }).then(function (body) {
        recent = Array.isArray(body.products) ? body.products : [];
        renderFresh();
      }).catch(function (error) { console.warn('Atlas recent maps unavailable', error); });
    }

    function popupFor(item) {
      var box = document.createElement('div');
      box.className = 'mc-atlas-popup';
      var name = document.createElement('strong');
      name.textContent = item.name;
      var link = document.createElement('a');
      link.href = item.url;
      link.textContent = 'See this map →';
      box.append(name);
      if (item.approximate) {
        var note = document.createElement('small');
        note.textContent = 'Approximate place location';
        note.style.display = 'block';
        box.append(note);
      }
      box.append(link);
      return box;
    }

    function cardFor(item, marker) {
      var card = document.createElement('div');
      card.className = 'mc-atlas-card';
      if (item.image) {
        var image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        card.append(image);
      }
      var copy = document.createElement('div');
      var name = document.createElement('strong');
      name.textContent = item.name;
      var type = document.createElement('small');
      type.textContent = (labels[item.kind] || 'Wood map') + (geographyText(item) ? ' · ' + geographyText(item) : '') + (item.approximate ? ' · approximate location' : '');
      var show = document.createElement('button');
      show.type = 'button';
      show.textContent = 'Show on map';
      show.style.cssText = 'border:0;background:none;padding:0;color:#a34425;text-decoration:underline;cursor:pointer;font:inherit;font-size:13px;margin-top:7px';
      show.addEventListener('click', function () {
        map.flyTo([item.lat, item.lng], Math.max(map.getZoom(), 9));
        marker.openPopup();
        root.querySelector('[data-atlas-map]').scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      var link = document.createElement('a');
      link.href = item.url;
      link.textContent = 'See this map →';
      link.style.cssText = 'display:block;color:#a34425;font-size:13px;margin-top:7px';
      copy.append(name, type, show, link);
      card.append(copy);
      return card;
    }

    function update() {
      var query = search.value.trim().toLocaleLowerCase();
      var selected = kind.value;
      var shown = data.filter(function (item) {
        return matchesGeography(item) && (selected === 'all' || item.kind === selected) &&
          (!query || (item.name + ' ' + item.title + ' ' + (item.states || []).join(' ') + ' ' + (item.counties || []).map(function (area) { return area.name; }).join(' ')).toLocaleLowerCase().includes(query));
      });
      markers.clearLayers();
      results.replaceChildren();
      count.textContent = shown.length + (shown.length === 1 ? ' featured place' : ' featured places');
      if (!shown.length) {
        var empty = document.createElement('p');
        empty.className = 'mc-atlas-empty';
        empty.textContent = 'No pinned places match this search. Check current listings below, or ask us to make a custom map.';
        results.append(empty);
        return;
      }
      var bounds = [];
      shown.forEach(function (item, index) {
        var marker = L.circleMarker([item.lat, item.lng], {
          radius: 8, color: '#fff', weight: 2, fillColor: '#a34425', fillOpacity: .95
        }).bindPopup(popupFor(item));
        marker.addTo(markers);
        bounds.push([item.lat, item.lng]);
        if (index < 100 || query) results.append(cardFor(item, marker));
      });
      if (shown.length > 100 && !query) {
        var more = document.createElement('p');
        more.className = 'mc-atlas-empty';
        more.textContent = 'Showing the first 100 places here. Search above to find any of the others on the map.';
        results.append(more);
      }
      if (shown.length === 1) map.flyTo(bounds[0], 8);
      else if (!query && selected === 'all' && (!state || state.value === 'all') && (!county || county.value === 'all')) map.setView([39.5, -96], 4);
      else map.fitBounds(bounds, { padding: [35, 35], maxZoom: 6 });
    }

    search.addEventListener('input', update);
    search.addEventListener('input', searchProducts);
    kind.addEventListener('change', update);
    kind.addEventListener('change', renderFresh);
    if (state) state.addEventListener('change', function () { updateCounties(); update(); renderFresh(); });
    if (county) county.addEventListener('change', function () { update(); renderFresh(); });
    if (reset) reset.addEventListener('click', function () {
      search.value = '';
      kind.value = 'all';
      if (state) state.value = 'all';
      updateCounties();
      searchProducts();
      update();
    });
    update();
    if (requestedPlace) searchProducts();
    setTimeout(function () { map.invalidateSize(); }, 100);
  }

  function init() {
    document.querySelectorAll('[data-atlas]').forEach(initAtlas);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();


